import { UploadFileApi } from "@/features/accounts/ocr/services/upload-file-api";
import { UploadFileRequestModel } from "@/features/accounts/ocr/services/upload-file-model";

/// OCR取込ファイルアップロード処理
export class UploadFileService {
  private uploadFileApi = new UploadFileApi();

  /**
   * OCR取込ファイルアップロードAPI実行
   */
  public async UploadFile(param: UploadFileRequestModel) {
    return await this.uploadFileApi.UploadFile(param);
  }
}
